<template>
    <div class="modal-window bds038">
        <header class="modal-header">
            <div class="tit">{{ $i18nUtil.trans("title.SetTagsModal.001","태그설정") }}</div>
            <button @click="closePopup" class="btn_close">닫기</button>
        </header>
        
        <div class="modal-content">
            <select class="sel_ty3" v-model="selectedJobGroup" @change="changeCondition()">
                <option :value="null" disabled>{{ $i18nUtil.trans("message.SetTagsModal.004","직군 선택") }}</option>
                <option v-for="(jobG, idx) in jobGroups" :key="'jobGroup_'+idx" :value="jobG.htagCategoryId">{{jobG.htagCategoryName}}</option> 
            </select>
            <div class="tag_sel_wrap">
                <div class="tag_sel">
                    <p class="nodata" v-if="selectedJobGroupYn"><span>{{ $i18nUtil.trans("message.SetTagsModal.001","직군을 먼저 선택하세요.") }}</span></p>
                    <span
                        v-for="(item, index) in tagItems" 
                        :key="index"
                    >
                        <input type="checkbox" :id="'tag_' + index" :value="item" v-model="selectedTags" @change="addTags"><label :for="'tag_' + index">{{ item.htag }}</label>
                    </span>
                    <!-- <span><input type="checkbox" name="" id="tag2"><label for="tag2">태그1</label></span> -->
                </div>
            </div>

            <div class="member_grp tag">
                <div class="scroll">
                    <p class="nodata" v-if="nodataYn"><span>{{$i18nUtil.trans('AB104')}}</span></p>
                    <div v-for="(item, index) in selectedTags" :key="'selectedTag_'+index">#{{item.htag}} <button type="button" @click="removeTag(item)">x</button></div>
                </div>
            </div>

        </div>

        <footer class="modal-footer">
            <button type="button" class="btn_ty1" @click="saveTagList()">{{ $i18nUtil.trans("button.save","저장") }}</button>
        </footer>
    </div>
</template>
<script>
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import EventBus from "@/js/eventbus/eventBus";
export default {
    props:["modalInfo"],
    components: {},
    data() {
        return { 
            nodataYn: true,
            tagItems: [],
            jobGroups : [],

            selectedJobGroup : null, // 선택된 직군.
            selectedJobGroupYn : true,
            selectedTags: [], // 선택된 태그 목록.

            toastInfo: {
                obj: this.$toasted,
                message: "",
                options: {
                    theme: "toasted-primary",
                    position: "bottom-left",
                    duration: 3000,
                },
            }, 
        };
    },
    created(){
        this.setJobGroups();
    },
    methods: {
        ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
        ...mapActions("modals", ["showModal","showToast"]),
        /* 직군 리스트 세팅. */
        setJobGroups(){ 
            let obj = this;
            let reqData = {};
            reqData.params ={}
            reqData.req = obj.req;
            reqData.url = "/api/copaper/tag/getJobGroupList";
            reqData.method = "post";
            obj.COWORK_REST_SIMPLE_ACTION(reqData)
            .then(res => {
                if(res.errorCode == null){
                    this.jobGroups = res.result.childJobGroups;
    
                    if(this.modalInfo.selectedJobGroup != null){
                        this.selectedJobGroup = this.modalInfo.selectedJobGroup;
                        this.selectedJobGroupYn = false;
                        this.setTagItems();
                    }
                }
            })
            .catch(function(err) {
                console.log(err);
            });
        },
        /* 태그 리스트 세팅. */
        setTagItems(){ 
            let obj = this;
            let reqData = {};
            reqData.params ={ 
                rootId : this.selectedJobGroup
            };
            reqData.req = obj.req;
            reqData.url = "/api/copaper/tag/getTagListByRootId";
            reqData.method = "post";
            obj.COWORK_REST_SIMPLE_ACTION(reqData)
            .then(res => {
                if(res.errorCode == null){
                    this.tagItems = res.result;
    
                    if(this.modalInfo.tagList.length != 0){
                        this.selectedTags = this.modalInfo.tagList.slice();
                        this.nodataYn = false;
                    }
                }
            })
            .catch(function(err) {
                console.log(err);
            });
        },
        /* 선택된 태그 지우기. */
        removeTag(item){
            let obj = this;
            this.selectedTags.forEach(function(tag, idx){
                if(tag.htagCategoryId === item.htagCategoryId){
                    obj.selectedTags.splice(idx,1);
                    return false;
                } 
            })

            if(this.selectedTags.length == 0 ){
                this.nodataYn = true;
            }
        },
        /* 직군 선택 */
        changeCondition(){
            /* 선택된 직군의 태그리스트 검색 */
            this.selectedJobGroupYn = false;
            this.tagItems = [];
            this.setTagItems();
        },
        /* 태그 선택 */
        addTags(){
            if(this.selectedTags.length > 3){
                let resultTags = this.selectedTags.splice(0,3);
                this.$nextTick(function(){
                    this.selectedTags = resultTags; 
                }) 
                this.showAlertDialog(this.$i18nUtil.trans('AB105'), null, {
                    width: "400px",
                    // height: "148px",
                });
            }else{ 
                this.nodataYn = false;
            } 
        },
        /* 태그 저장. */
        saveTagList(){
            if(this.selectedTags.length == 0){
                this.showAlertDialog(this.$i18nUtil.trans('AB104'), null, {
                    width: "400px",
                    // height: "148px",
                });
                return;
            }
            
            EventBus.$emit("returnSelectedTags", {
                tagList : this.selectedTags,
                selectedJobGroup : this.selectedJobGroup
            });
            this.closePopup();
        },
        closePopup() {
            let body = document.querySelector("body");
            body.style.removeProperty("overflow");
            this.$emit("close");
        },
    },
}
</script>


// WEBPACK FOOTER //
// src/components/cowork/general/board/modal/SetTagsModal.vue